import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRoomPkRankInfo = createAsyncThunk(
  'CrossRoomPkRank/getRankTaskInfo',
  async ({type, offset = 0}: {type: 0 | 1 | 2; offset: number}, store: any) => {
    const resp = await http.post('/live/pk/stage_rank', {
      ...store.getState().env.deviceinfo,
      type,
      offset,
    })
    return {data: resp.data, type, offset}
  }
)
export const getRoomPkRankReward = createAsyncThunk(
  'CrossRoomPkRank/getRoomPkRankReward',
  async ({type}: {type: 0 | 1}, store: any) => {
    const resp = await http.post('/live/pk/stage_reward', {
      ...store.getState().env.deviceinfo,
      type,
    })
    return {data: resp.data, type}
  }
)
interface itemProp {
  mid: number
  name: string
  avatar: string
  rank: number
  score: number
  pk_level: string
  level_icon: string
  mvp_mid: number
  mvp_name: string
  mvp_avatar: string
  mvp_score: number
}

interface RewardProps {
  over_all_ranking: string
  reward_list: Array<{
    icon: string
    desc: string
  }>
}
const initialState: {
  winningRank: {
    list: Array<itemProp>
    offset: number
    more: boolean
  }
  pointRank: {list: Array<itemProp>; offset: number; more: boolean}
  normalRank: {list: Array<itemProp>; offset: number; more: boolean}
  stage: string
  start_time: string
  end_time: string
  ownerRewardList: Array<RewardProps>
  userRewardList: Array<RewardProps>
  pointRewardList: Array<RewardProps>
} = {
  winningRank: {
    list: [],
    offset: 0,
    more: false,
  },
  pointRank: {
    list: [],
    offset: 0,
    more: false,
  },
  normalRank: {
    list: [],
    offset: 0,
    more: false,
  },
  stage: '', // 赛季信息：s22赛季
  start_time: '', // 开始时间
  end_time: '', // 结束时间
  ownerRewardList: [],
  pointRewardList: [],
  userRewardList: [],
}

export const CrossRoomPkRankSlice = createSlice({
  name: 'rankTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoomPkRankInfo.fulfilled, (state, action) => {
      const {
        data: {data},
        type,
        offset,
      } = action.payload
      if (type === 0) {
        Object.assign(state, {
          normalRank: {
            list:
              offset > 0 ? [...state.normalRank.list, ...data.list] : data.list,
            offset: data.offset,
            more: data.more,
          },
          ...data,
        })
      } else if (type === 1) {
        Object.assign(state, {
          pointRank: {
            list:
              offset > 0 ? [...state.pointRank.list, ...data.list] : data.list,
            offset: data.offset,
            more: data.more,
          },
          ...data,
        })
      } else {
        Object.assign(state, {
          winningRank: {
            list:
              offset > 0
                ? [...state.winningRank.list, ...data.list]
                : data.list,
            offset: data.offset,
            more: data.more,
          },
          ...data,
        })
      }
    })
    builder.addCase(getRoomPkRankReward.fulfilled, (state, action) => {
      const {
        data: {data},
        type,
      } = action.payload
      if (type === 0) {
        Object.assign(state, {
          pointRewardList: data.list,
          ownerRewardList: data.score_list,
        })
      } else {
        Object.assign(state, {userRewardList: data.list})
      }
    })
  },
})
export default CrossRoomPkRankSlice.reducer
